#import './email-sequence-template-stub-fragment.graphql'

fragment EmailSequenceTemplateFullFragment on EmailSequenceTemplate {
    ...EmailSequenceTemplateStubFragment
    replyRate
    replyCount
    clickRate
    clickCount
    inProgressCount
    finishedCount
    cancelledCount
    startedWithClickTrackingCount
}
